import differenceInSeconds from 'date-fns/differenceInSeconds'
import parseISO from 'date-fns/parseISO'

import type {State} from '../../../../../../reducers/types'
import {getBuild} from '../../../../../../selectors'

export const getBuildDuration = (state: State, buildId: number) => {
  const {startDate, finishDate, 'running-info': runningInfo} = getBuild(state, buildId) ?? {}
  if (runningInfo != null) {
    return runningInfo.elapsedSeconds ?? 0
  }
  if (startDate != null && finishDate != null) {
    return differenceInSeconds(parseISO(finishDate), parseISO(startDate))
  }
  return 0
}

export const getBuildTimeInQueue = (state: State, buildId: number) => {
  const {queuedDate, startDate} = getBuild(state, buildId) ?? {}
  if (queuedDate != null) {
    return differenceInSeconds(
      startDate != null ? parseISO(startDate) : Date.now(),
      parseISO(queuedDate),
    )
  }
  return 0
}
